var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{attrs:{"src":_vm.getPath,"width":"100px"}}),_c('p',{staticClass:"white--text"},[_vm._v("TEXTO A POR")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }